/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

/**
 *
 * @export
 * @interface CancelReaderActivityDTO
 */
export interface CancelReaderActivityDTOOptional {
  /**
   *
   * @type {string}
   * @memberof CancelReaderActivityDTO
   */
  readerId?: string;
}

export interface CancelReaderActivityDTO extends CancelReaderActivityDTOOptional {
  /**
   *
   * @type {string}
   * @memberof CancelReaderActivityDTO
   */
  readerId: string;
}

export interface CancelReaderActivityDTOTrackedI {
  /**
   *
   * @type {string}
   * @memberof CancelReaderActivityDTO
   */
  readerId?: string;
  readerIdIsSet: boolean;
}

transformDatesMap.set(
  "CancelReaderActivityDTO",
  function (model: CancelReaderActivityDTO) {},
);

export type CancelReaderActivityDTOMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  readerId: PropertyMeta<MetaTypeBase<string>>;
}>;

export var CancelReaderActivityDTOMeta: CancelReaderActivityDTOMetaI =
  {} as CancelReaderActivityDTOMetaI;
CancelReaderActivityDTOMeta = typeMeta("CancelReaderActivityDTO", {
  readerId: propertyMeta("readerId", false, true, false, MetaTypesBase.string),
});

const metaI = CancelReaderActivityDTOMeta;

registerMeta(() => {});

export class CancelReaderActivityDTOTracked implements CancelReaderActivityDTOTrackedI {
  changeTracker: boolean = false;
  //isNew: boolean = false
  readerId__I?: string = undefined;
  readerIdIsSet: boolean = false;
  set readerId(v: undefined | string) {
    if (v !== undefined) {
      this.readerId__I = v;
      this.readerIdIsSet = true;
    } else {
      this.readerId__I = v || undefined;
      this.readerIdIsSet = true;
    }
    this.changeTracker = true;
  }
  get readerId() {
    return this.readerId__I;
  }
  constructor(
    config?: CancelReaderActivityDTOOptional,
    options?: AssignOptions,
  ) {
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    return this == other;
  }
  setIds() {}
  assignFrom(
    config: CancelReaderActivityDTOOptional,
    options?: AssignOptions,
  ): CancelReaderActivityDTOTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (config.readerId && this.readerIdApplyFilter(optionsRequired.filter)) {
      this.readerId = config.readerId;
      if (optionsRequired.unassign) this.readerIdIsSet = false;
      else this.readerIdIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): CancelReaderActivityDTOTrackedI {
    const cloned = {} as CancelReaderActivityDTOTrackedI;
    if (
      this.readerIdIsSetDeep() &&
      this.readerIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.readerIdIsSet = true;
      cloned.readerId = this.readerId;
    } else {
      //cloned.readerIdIsSet = false
    }
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): CancelReaderActivityDTOTrackedI {
    if (!this.readerIdApplyFilter(filter)) this.readerIdIsSet = false;

    return this;
  }
  readerIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CancelReaderActivityDTOMeta.readerId,
      CancelReaderActivityDTOMeta,
      this.readerId,
      this,
    );
  }
  readerIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.readerIdIsSet && this.readerIdApplyFilter(filter)) return true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.readerIdIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
